/** @format */

import axios from "axios";
import { useAppSelector } from "../Global/Store";

import { UserData, iAppointment } from "../interface/interface";

// const userOne = useAppSelector((state) => state?.currentUser);

interface iData {
  name: string;
  amount: number;
  number: string;
  cvv: string;
  expiry_month: string;
  expiry_year: string;
}

const lifeUrl = "https://codecrusaderslifecare.onrender.com/api";

const localHost = "";

export const signup = async ({
  userName,
  email,
  password,
  confirmPassword,
}: any) => {
  return await axios
    .post(`${lifeUrl}/pageoneregister`, {
      userName,
      email,
      password,
      confirmPassword,
    })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return err;
    });
};

export const userSignup2 = async (
  {
    fullName,
    phoneNumber,
    genotype,
    bloodGroup,
    dateOfBirth_month,
    dateOfBirth_day,
    dateOfBirth_year,
  }: any,
  id: any
) => {
  return await axios
    .patch(`${lifeUrl}/pagetworegister/${id}`, {
      fullName,
      phoneNumber,
      genotype,
      bloodGroup,
      dateOfBirth_month,
      dateOfBirth_day,
      dateOfBirth_year,
    })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return err;
    });
};

export const userSignup3 = async (data: UserData, id: any) => {
  return await axios
    .patch(`${lifeUrl}/pagethreeregister/${id}`, data)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return err;
    });
};

export const createSpecialist = async ({
  name,
  email,
  password,
  lience,
  profession,
}: any) => {
  return await axios
    .post(
      `${lifeUrl}/createspecialist`,
      // .post (`http://localhost:2001/api/createspecialist`,
      {
        name,
        email,
        password,
        lience,
      }
    )
    .then((res) => {
      return res.data;
    });
};

export const signin = async ({ email, password }: any) => {
  return await axios
    .post(
      `${lifeUrl}/login`,
      // .post(`http://localhost:2001/api/login`,
      {
        email,
        password,
      }
    )
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return err;
    });
};

export const loginspecialist = async ({ email, password }: any) => {
  return await axios
    .post(
      `${lifeUrl}/loginspecialist`,
      // .post(`http://localhost:2001/api/login`,
      {
        email,
        password,
      }
    )
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return err;
    });
};

export const GetOneUser = async (id: any) => {
  return await axios
    .get(`${lifeUrl}/getoneuser/${id}/`)
    // .get(`http://localhost:2001/api/getoneuser/${id}/`)
    .then((res) => res.data);
};

export const GetOneSpecialist = async (id: any) => {
  return await axios
    .get(`${lifeUrl}/getonespecialist/${id}`)
    // .get(`http://localhost:2001/api/getonespecialist/${id}`)
    .then((res) => res.data);
};

export const sendToSpecialist = async (
  { amount, accountNumber }: any,
  id: any
) => {
  return await axios
    .patch(
      `${lifeUrl}/sendtospecialist/${id}`,
      // .patch(`http://localhost:2001/api/sendtospecialist/${id}`,
      {
        amount,
        accountNumber,
      }
    )
    .then((res) => res.data);
};

export const sendToHospital = async (id: any) => {
  return await axios
    .patch(`.${lifeUrl}/sendtohospital/${id}/${id}`)
    .then((res) => res.data);
};

export const sendToOtherWallet = async (id: any) => {
  return await axios.patch(`${lifeUrl}/transfer/${id}`).then((res) => res.data);
  // .patch(`http://localhost:2001/api/transfer/${id}`).then((res) => res.data)
};

export const fundFromBank = async (
  { amount, number, cvv, expiry_month, expiry_year }: iData,
  id: string
) => {
  return await axios
    .post(
      `${lifeUrl}/fundWallet/${id}`,
      // .post (`http://localhost:2001/api/fundwallet/${id}`,
      {
        cvv,
        amount,
        number,
        expiry_month,
        expiry_year,
        id,
      }
    )
    .then((res) => {
      return res.data;
    });
};

export const payTobank = async ({ amount }: any, id: any) => {
  return await axios

    .post(`${lifeUrl}/payout/${id}`, {
      amount,
    })
    .then((res) => res.data)
    .catch((err) => err);
};

export const bookAppointment = async (
  data: iAppointment,
  userID: string,
  specialistID: string
) => {
  return await axios
    .post(`${lifeUrl}/bookAppointment/${userID}/${specialistID}`, data)
    .then((res) => res.data)
    .catch((err) => {
      return err;
    });
};

export const settings = async (data: UserData, userId: string) => {
  return await axios
    .patch(`${lifeUrl}/settings/${userId}`, data)
    .then((res) => res.data)
    .catch((err) => err);
};
